module.exports = __webpack_public_path__ + "static/img/userpop.c9b51c0b.png";